import { render, staticRenderFns } from "./School.vue?vue&type=template&id=591bef33&scoped=true&"
import script from "./School.vue?vue&type=script&lang=js&"
export * from "./School.vue?vue&type=script&lang=js&"
import style0 from "./School.vue?vue&type=style&index=0&id=591bef33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bef33",
  null
  
)

export default component.exports